import { render, staticRenderFns } from "./CircularSectorSelection.vue?vue&type=template&id=9906ece6&"
import script from "./CircularSectorSelection.vue?vue&type=script&lang=js&"
export * from "./CircularSectorSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports